import React, { useState } from 'react';
import { Button, Message, Modal, Progress, Table, Uploader, useToaster } from 'rsuite';
import api from '../../config/api';
import { getPlanningByWeeks } from '@/services/wfhProfile.service';
import { useAppDispatch, useAppSelector } from '@/config/hooks';
import { useTranslation } from 'react-i18next';

const { Column, HeaderCell, Cell } = Table;

const ModalUploadPlanning = ({ open, setOpen, weeks, year }) => {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [results, setResults] = useState([]);
  const toaster = useToaster();
  const dispatch = useAppDispatch();

  const users = useAppSelector((state: any) => state.users.team);
  const { t } = useTranslation();

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      setUploading(true);
      const response = await api.post(`${process.env.REACT_APP_API_URL}wfhProfile/planning/upload-planning`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: e => {
          const percent = Math.round((e.loaded * 100) / e.total);
          setProgress(percent);
        }
      });
      const uploadResult = response.data.data;

      //   if (uploadResult?.errors?.length > 0) {
      //     setErrors(uploadResult?.errors);
      //   }

      const merged = [
        ...uploadResult?.errors,
        ...uploadResult.results.filter(
          r => !uploadResult.errors.find(e => e['Registration number'] === r['Registration number'])
        )
      ].map(item => ({
        registrationNumber: item['Registration number'],
        error: item.error || '✅ ' + item.status
      }));
      setResults(merged);

      if (uploadResult?.successCount == 0 && uploadResult?.errorCount > 0) {
        toaster.push(
          <Message showIcon type="error">
            Import failed!
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        toaster.push(
          <Message showIcon type="success">
            Import completed!
          </Message>,
          { placement: 'topEnd' }
        );
        const weekList = Array.from(weeks, ({ weekNumber }) => weekNumber);
        dispatch(getPlanningByWeeks({ userIds: users, weeks: weekList, year }));

        // setOpen(false);
        setFile(null);
        setProgress(0);
      }
    } catch (err) {
      console.error(err);
      toaster.push(
        <Message showIcon type="error">
          Import failed!
        </Message>,
        { placement: 'topEnd' }
      );
    } finally {
      setUploading(false);
    }
  };
  return (
    <div>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Modal.Header>
          <Modal.Title>Import Excel File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Uploader
            autoUpload={false}
            // fileList={file ? [file] : []}
            onChange={files => {
              setFile(files[0]?.blobFile || null);
              setErrors([]);
            }}
            draggable
            accept=".xlsx,.xls"
            multiple={false}
            onRemove={() => setErrors([])}
            onReupload={() => setErrors([])}
          >
            <div style={{ padding: 20, textAlign: 'center' }}>Click or drag file to this area</div>
          </Uploader>

          {uploading && (
            <Progress.Line percent={progress} showInfo strokeColor="var(--rs-primary-500)" style={{ marginTop: 20 }} />
          )}

          {results?.length > 0 && (
            <Table
              data={results || []}
              height={200}
              bordered
              cellBordered
              autoHeight
              style={{ marginTop: 20 }}
              wordWrap="break-word"
            >
              <Column flexGrow={1}>
                <HeaderCell>User</HeaderCell>
                <Cell dataKey="registrationNumber" style={{ whiteSpace: 'pre-line' }} />
              </Column>

              <Column flexGrow={3}>
                <HeaderCell>Message</HeaderCell>
                <Cell dataKey="error" style={{ whiteSpace: 'pre-line' }} />
              </Column>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleUpload} appearance="primary" disabled={!file || uploading}>
            {uploading ? t('Uploading...') : t('Start Import')}
          </Button>
          <Button onClick={() => setOpen(false)} appearance="subtle">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalUploadPlanning;
